import { Component, OnInit } from '@angular/core';
import { ApplicationService } from '../services/application.service'
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  partnerName: string = ''
  partnerType: string = ''
  isAdmin: boolean = false;
  partnerTypeId: string = '';
  profileImage: string = '';
  constructor(private _applicationService: ApplicationService, private router: Router) {
    let loginUser = JSON.parse(localStorage.getItem('currentUser'));
    if (loginUser) {
      if (loginUser.isAdmin) {
        this.partnerName = loginUser.userDetail.name;
        this.isAdmin = loginUser.isAdmin;
        this.profileImage = loginUser.userDetail.profileImage;
        this.partnerTypeId = "-1";
        this._applicationService.loginUserDetails.userid = loginUser.userDetail.id;
        this._applicationService.loginUserDetails.token = loginUser.token;
        this._applicationService.loginUserDetails.name = loginUser.userDetail.name;
        this._applicationService.loginUserDetails.isAdmin = true;
        this._applicationService.loginUserDetails.profileImage = loginUser.userDetail.profileImage;
        this._applicationService.loginUserDetails.partnertypeId = "-1";
        this._applicationService.loginUserDetails.partnertype = "Administrator";
      }
      else {

        this.partnerName = loginUser.userDetail.partnerName;
        this.isAdmin = loginUser.isAdmin;
        this.profileImage = loginUser.userDetail.partnerProfileImage;
        this.partnerTypeId =loginUser.userDetail.partnertypeid;

        this._applicationService.loginUserDetails.userid = loginUser.userDetail.partnerId;
        this._applicationService.loginUserDetails.token = loginUser.token;
        this._applicationService.loginUserDetails.name = loginUser.userDetail.partnerName;
        this._applicationService.loginUserDetails.isAdmin = false;
        this._applicationService.loginUserDetails.profileImage = loginUser.userDetail.partnerProfileImage;
        this._applicationService.loginUserDetails.partnertypeId = loginUser.userDetail.partnertypeid;
        this._applicationService.loginUserDetails.partnertype = loginUser.userDetail.partnerType;

      }

    }





  }

  ngOnInit() {
  }

}
